import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { TwoWayBoundComponent } from '@app/shared/components/base/two-way-bound.component';
import {
    CaseNoField,
    CaseNoStructure,
    CounterResetMethods,
    FieldCode, FieldCodes,
    GenerationMethod,
    GenerationMethods
} from '@app/shared/models/case-number-settings';

@Component({
    selector: 'case-number-structure',
    templateUrl: './case-number-structure.component.html',
    styleUrls: ['./case-number-structure.component.scss']
})
export class CaseNumberStructureComponent extends TwoWayBoundComponent<CaseNoStructure>
                                          implements OnInit, OnChanges {

    @Input()
    protected availableFields: CaseNoField[];

    @Output()
    public canceled = new EventEmitter();

    public filteredAvailableFields: CaseNoField[];

    public sliderConfig = {
      min: 2,
      max: 6,
      step: 1,
      tickInterval: 1,
      thumbLabel: false
    };

    public sliderSteps = [2, 3, 4, 5, 6];

    get FieldCode() {
        return FieldCode;
    }

    get FieldCodes() {
        return FieldCodes;
    }

    get structure() {
        return this.bananaBox;
    }

    get CounterResetMethods() {
        return CounterResetMethods;
    }

    get GenerationMethods() {
        return GenerationMethods;
    }

    get isAutomatic(): boolean {
        return this.structure.generation_method === GenerationMethod.AUTOMATIC;
    }

    constructor() {
        super();
        this._idPrefix = 'case-number-structure.';
    }

    public ngOnInit() {
        super.ngOnInit();
    }

    public ngOnChanges(changes: SimpleChanges) {
        if (changes.bananaBox && changes.bananaBox.previousValue !== changes.bananaBox.currentValue) {
            this.filterAvailableFields();
        }
    }

    public filterAvailableFields(): void {
        this.filteredAvailableFields = this.availableFields.filter(field => {
           return field.isSeparator || !this.structure.fields.find(selectedField => selectedField.identifier_code === field.identifier_code);
        });
    }

    public numberAsNumberArray(num: number): number[] {
        const arr = new Array<number>();

        if (!isNaN(num)) {
            for (let i = 1; i <= num; i++) {
                arr.push(i);
            }
        }

        return arr;
    }

    public save(): void {
        this.onChange();
    }

    public cancel(): void {
        this.canceled.emit();
    }
}
